/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MachineSaleListModel,
    MachineSaleListModelFromJSON,
    MachineSaleListModelFromJSONTyped,
    MachineSaleListModelToJSON,
} from './MachineSaleListModel';

/**
 * 
 * @export
 * @interface MachineSaleListModelPagedDataModel
 */
export interface MachineSaleListModelPagedDataModel {
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModelPagedDataModel
     */
    pageNo?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModelPagedDataModel
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModelPagedDataModel
     */
    readonly rowIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModelPagedDataModel
     */
    readonly pageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModelPagedDataModel
     */
    itemCount?: number;
    /**
     * 
     * @type {Array<MachineSaleListModel>}
     * @memberof MachineSaleListModelPagedDataModel
     */
    data?: Array<MachineSaleListModel> | null;
}

export function MachineSaleListModelPagedDataModelFromJSON(json: any): MachineSaleListModelPagedDataModel {
    return MachineSaleListModelPagedDataModelFromJSONTyped(json, false);
}

export function MachineSaleListModelPagedDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineSaleListModelPagedDataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageNo': !exists(json, 'pageNo') ? undefined : json['pageNo'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'rowIndex': !exists(json, 'rowIndex') ? undefined : json['rowIndex'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'itemCount': !exists(json, 'itemCount') ? undefined : json['itemCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(MachineSaleListModelFromJSON)),
    };
}

export function MachineSaleListModelPagedDataModelToJSON(value?: MachineSaleListModelPagedDataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pageNo': value.pageNo,
        'pageSize': value.pageSize,
        'itemCount': value.itemCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(MachineSaleListModelToJSON)),
    };
}

